module.exports = __webpack_public_path__ + "img/avatar5.a3263b87.png";